module.exports = __webpack_public_path__ + "media/application/images/checkbox-352e245f3e8884a61469155d2b65e2d4.svg";